// Public request forms must not accept a project window in the past (a
// requester once typed 2016 instead of 2026). The backend rejects it too;
// `min` makes the browser grey out past days and block a typed past date.

/** Today as YYYY-MM-DD in the browser's local zone - the format `<input type="date">` uses. */
export function todayIso(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Sets `min` = today on the given date inputs. */
export function setMinToday(...ids: string[]): void {
  const today = todayIso();
  for (const id of ids) {
    const input = document.getElementById(id) as HTMLInputElement | null;
    if (input) input.min = today;
  }
}
